<template>
  <button @click="click" class="button-cancel" :disabled="load">
	<ArrowPathIcon class="icon" :class="{'animate-spin': load}" />
    <slot>
      Aktualisieren
    </slot>
  </button>
</template>

<script setup>
const props = defineProps({load: Boolean});
const emits = defineEmits(['click']);
const click = () => emits('click');
</script>

<style scoped>
.icon
{
  @apply flex-shrink-0;
  @apply mr-1.5 h-5 w-5;
  @apply text-gray-400;
};
</style>
